import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class BannerReviewQueryService {
    private CREATE_TESTIMONIAL: any;
    private GET_ALL_TESTIMONIAL: any;
    private DELETE_TESTIMONIAL: any;
    private UPDATE_TESTIMONIAL: any;

    constructor(public apollo: Apollo) {
        this.CREATE_TESTIMONIAL = gql`
    mutation createBannerReviews($input:CreateBannerReviewInput!) {
        createBannerReview(input:$input) {
             bannerReview {
                 bannerReviewId
              imageUrl
              description
              isDeletedYn
              createdat
              updatedat
            }
          }
        }
      `;

        this.GET_ALL_TESTIMONIAL = gql`
    query BannerReviews {
        allBannerReviews(filter: {isDeletedYn: {equalTo: false}}) {
          nodes {
            bannerReviewId
            imageUrl
            description
            isDeletedYn
            createdat
            updatedat
          }
          totalCount
        }
      }`;

        this.UPDATE_TESTIMONIAL = gql`
    mutation updateBannerReviews($input:UpdateBannerReviewByBannerReviewIdInput!) {
        updateBannerReviewByBannerReviewId(input:$input) {
             bannerReview{
                bannerReviewId
              imageUrl
              description
              isDeletedYn
              createdat
              updatedat
            }
          }
        }
            `;

        this.DELETE_TESTIMONIAL = gql`
    mutation updateIsDeletedYnForBannerReviews($input:UpdateBannerReviewByBannerReviewIdInput!) {
        updateBannerReviewByBannerReviewId(input:$input) {
             bannerReview{
              bannerReviewId
              imageUrl
              description
             isDeletedYn
             createdat
             updatedat
            }
          }
        }
        `;
    }

    // Uplaod new banner
    ADD_TESTIMONIAL(formValue) {
        return this.apollo.mutate({
            mutation: this.CREATE_TESTIMONIAL,
            variables: {
                "input": {
                    "bannerReview": formValue
                }
            },
        })
    }


    // GET all banners list
    GET_TESTIMONIALS(payload) {
        return this.apollo.watchQuery({
            query: this.GET_ALL_TESTIMONIAL,
            variables: payload,
            fetchPolicy: 'network-only'
        })
    }

    //update all testimonials
    EDIT_TESTIMONIALS(bannerID, formValue) {
        return this.apollo.mutate({
            mutation: this.UPDATE_TESTIMONIAL,
            variables: {
                "input": {
                    "bannerReviewId": bannerID,
                    "bannerReviewPatch": formValue
                }
            }
        })
    }

    //Delete banner
    DELETE_BANNER(formValue) {
        return this.apollo.mutate({
            mutation: this.DELETE_TESTIMONIAL,
            variables: {
                "input": formValue
            }
        })
    }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/bannerReview.ts